import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBUn6vB0OtEFzXyEbXC92v5gbR5LQrOKUw",
  authDomain: "odescalchi-1.firebaseapp.com",
  projectId: "odescalchi-1",
  storageBucket: "odescalchi-1.appspot.com",
  messagingSenderId: "57373002723",
  appId: "1:57373002723:web:eee24f6a60ffb82acd2ed6",
  measurementId: "G-B59XMNC51G"
};

let Firebase = firebase.initializeApp(firebaseConfig);
Firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

Firebase.firestore()
  .enablePersistence()
  .catch(err => console.log(err));

export default Firebase;
